import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import logoPilari from "../assets/images/pilari_light.png";
import logoPilariPrint from "../assets/images/pilari_dark.png";
import logoGZW from "../assets/images/gzw.png";
import pilariQRLogo from "../assets/icons/pilari_logo_outline.png";
import { Download, Smartphone, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

const InstallPage = () => {
  const { t } = useTranslation();
  const installLink = "https://pilari.app/install";

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-300 py-24 px-4 font-sans">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-3xl shadow-xl overflow-hidden transition-colors duration-300">
        {/* Hero Section */}
        <div className="relative h-[320px] sm:h-[400px]">
          <img
            src={require("../assets/images/cikuray.webp")}
            alt="Gunung Cikuray"
            className="absolute inset-0 w-full h-full object-cover brightness-75"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
            <img
              src={logoPilari}
              alt="Logo PILARI"
              className="w-20 sm:w-24 mb-3 drop-shadow-md"
            />
            <h1 className="text-3xl sm:text-4xl font-bold drop-shadow-lg">
              {t("install.title")}
            </h1>
            <p className="text-sm sm:text-base font-medium drop-shadow-sm mt-2">
              {t("install.subtitle")}
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="p-8 space-y-10 text-sm sm:text-base text-gray-700 dark:text-gray-200 text-center">
          <p className="text-red-600 font-medium text-sm">
            ⚠️ {t("install.androidOnly")}
          </p>

          <a
            href="/assets/pilari-release.apk"
            download
            className="inline-flex items-center gap-2 px-6 py-3 bg-green-700 text-white rounded-md shadow hover:bg-green-800 transition"
          >
            <Download className="w-4 h-4" />
            {t("install.downloadNow")}
          </a>

          <p className="text-xs text-gray-500 dark:text-gray-400">
            {t("install.permissionNote")}
          </p>

          {/* QR Section */}
          <div className="space-y-4 print:h-[100vh] print:flex print:flex-col print:justify-center print:items-center">
            <p className="text-sm font-medium text-gray-800 dark:text-gray-100">
              {t("install.orScan")}
            </p>

            <div id="printable-qr-section" className="flex flex-col items-center justify-center gap-6 pt-5 print:items-center print:gap-2">
              <img
                src={logoPilariPrint}
                alt="Logo PILARI"
                className="w-48 h-auto print-logo"
              />

              <div style={{ position: "relative", width: 300, height: 300 }}>
                <QRCodeCanvas value={installLink} size={300} />
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 64,
                    height: 64,
                    zIndex: 10,
                    pointerEvents: "none",
                  }}
                >
                  <img
                    src={pilariQRLogo}
                    alt="Pilari QR Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </div>

              <div className="text-center print:text-center">
                <p>📱 {t("install.scanText")}</p>
                <p className="mt-2">{installLink}</p>
              </div>
            </div>

            <button
              onClick={() => window.print()}
              className="mt-3 px-4 py-2 text-sm bg-gray-800 text-white rounded hover:bg-gray-900 print:hidden"
            >
              {t("install.print")}
            </button>
          </div>

          {/* Installation Guide */}
          <section className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-700 shadow px-6 py-6 text-left">
            <h2 className="text-base font-semibold text-green-700 flex items-center gap-2 mb-4">
              <Smartphone className="w-5 h-5" />
              {t("install.installStepsTitle")}
            </h2>
            <ol className="list-decimal list-inside text-sm space-y-1">
              {Array.from({ length: 5 }).map((_, idx) => (
                <li key={idx}>{t(`install.steps.${idx}`)}</li>
              ))}
            </ol>
          </section>

          {/* Share */}
          <section className="text-center">
            <a
              href={`https://wa.me/?text=${encodeURIComponent(
                t("install.shareMessage", { link: installLink })
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2 bg-green-600 text-white text-sm rounded-md hover:bg-green-700 transition"
            >
              <FileText className="w-4 h-4" />
              {t("install.shareButton")}
            </a>
          </section>
        </div>

        {/* Footer */}
        <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 text-center py-4">
          <div className="inline-flex items-center justify-center gap-2 text-xs text-gray-500 dark:text-gray-400">
            <span>{t("install.poweredBy")}</span>
            <img src={logoGZW} alt="Garut Zero Waste" className="h-8" />
          </div>
        </footer>
      </div>
    </div>
  );
};

export default InstallPage;
